import { memo } from 'react';
import { classNames } from 'src/shared/lib/helpers/classNames';
import cls from './PostCardActionIcon.module.scss';

interface IPostCardActionIconProps {
  onClick: () => void;
  image: string;
  direction?: 'left' | 'right';
}

export const PostCardActionIcon = memo(({
  onClick,
  image,
  direction = 'right'
}: IPostCardActionIconProps) => (
  <button
    className={classNames(cls.button, {}, [cls[direction]])}
    type='button'
    onClick={onClick}
  >
    <img
      className={cls.img}
      src={image}
      alt='downloadPostCard'
    />
  </button>
));
